import React from "react";
import { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import luxuryBanner from "../../assets/images/banners/luxuryBanner.jpg";
import brochure from "../../assets/images/pdf/brochure.pdf";
import trees from "../../assets/images/icons/TRees.png";
import security from "../../assets/images/icons/security.png";
import ready from "../../assets/images/icons/readytoconstruct.png";
import eb from "../../assets/images/icons/EB-Connection.png";
import wall from "../../assets/images/icons/compoundwall.png";
import gwater from "../../assets/images/icons/Ground-water.png";
import arch from "../../assets/images/icons/Arch.png";
import solar from "../../assets/images/icons/Solar-lights.png";
import cctv from "../../assets/images/icons/CCTV.png";
import { useNavigate } from "react-router-dom";
// import brochureIcon from './assets/save.png'; // Replace with your actual path
// import heroImage from './assets/albero-image.webp'; // Replace with your actual path
const AboutOverview = () => {
  const navigate = useNavigate();
const amenitiesList = [
  {
    name: 'CCTV Surveillance',
    icon: cctv,
  },
  {
    name: '24 / 7 Security Service',
    icon: security,
  },
  {
    name: 'Ready To Construct',
    icon: ready,
  },
  {
    name: 'EB Provided',
    icon: eb,
  },
  {
    name: 'Fully Compounded Wall',
    icon: wall,
  },
  {
    name: 'Portable Ground Water',
    icon: gwater,
  },
  {
    name: 'Street Lights',
    icon: solar,
  },
  {
    name: 'Avenue Trees',
    icon: trees,
  },
];

  const scrollToSection = (id) => {
  navigate(`#${id}`, { replace: false });
    const section = document.getElementById(id);
    if (section) {
      const offsetTop = section.offsetTop - 80; // Leave 100px space at the topMore actions
    window.scrollTo({
      top: offsetTop,
      behavior: "smooth",
    });
  }
  };

useEffect(() => {
  AOS.init({ duration: 800, once: true });
}, []);
  return (
    <>
    {/* <div id="home-anchor" className="section-anchor"></div> */}
    <section id="about" className="overview-section py-3">
      <div className="px-md-5 px-3">
        <div className="row align-items-center g-5">
          {/* Content Section */}
          <div className="col-md-6">
            <h2 className="display-6 fw-bold mb-3" data-aos="fade-up">
              Plots in Pattabiram, Chennai <br /> <span className="underline-slide">GP PonBhoomi</span>
            </h2>

            {/* Desktop Paragraph */}
            <p className="lead d-lg-block d-none">
              Strategically located on the Chennai-Tiruvallur Highway (near
              Avadi), PonBhoomi offers 207 premium villa plots ranging from 450
              to 3,758 sq. ft. This well-connected residential community
              provides seamless access to key locations in Avadi, ensuring
              convenience and modern living. With shopping malls, movie
              theatres, schools, and hospitals nearby, PonBhoomi is an ideal
              choice for homeowners and investors alike.
            </p>

            {/* Mobile Paragraph */}
            <p className="d-block d-lg-none">
              Strategically located on the Chennai-Tiruvallur Highway (near
              Avadi), PonBhoomi offers 207 premium villa plots ranging from 450
              to 3,758 sq. ft. This well-connected residential community
              provides seamless access to key locations in Avadi, ensuring
              convenience and modern living. With shopping malls, movie
              theatres, schools, and hospitals nearby, PonBhoomi is an ideal
              choice for homeowners and investors alike.
            </p>

            {/* Amenities Section */}
            <div className="mt-4">
              <h4 className="fw-bold mb-3">Amenities</h4>
              <div className="row g-3">
                {amenitiesList.map((amenity, index) => (
                  <div className="col-6" key={index}>
                    <div className="d-flex align-items-center">
                      <img
                        src={amenity.icon}
                        alt={amenity.name}
                        width="45"
                        className="me-4 img-fluid"
                      />
                      <span className="small">{amenity.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Brochure Button */}
            <a
              onClick={() => scrollToSection("Contact")}
              // onClick={(e) => {
              //   e.preventDefault(); // Prevent page jump
              //   scrollToSection("home");
              // }}
              className="btn btn-primary d-inline-flex align-items-center mt-4"
            >
              <img
                src="https://cdn.prod.website-files.com/67dab0e3d24d389b189dcbd2/67db009cf131c008c28038d0_save.png"
                alt="Download"
                className="me-2" 
                width={20}
              />
              Download Brochure
            </a>
          </div>

          {/* Image Section */}
          <div className="col-md-6">
            <img
              src={luxuryBanner}
              alt="Albero Exterior"
              className="img-fluid rounded shadow d-none d-md-block"
            />
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default AboutOverview;
